// extracted by mini-css-extract-plugin
export var closeButton = "_kl-1";
export var closeX = "_kl-3";
export var container = "_kl-0";
export var image = "_kl-2";